export const TIMING = Object.freeze({
  UI: {
    START_UI_REVEAL: 1500,
    BLACKOUT_TIMER: 200,
    BLACKOUT_WAIT_TO_REVEAL: 50,
  },
  VIDEO: {
    VID_END_TIMER: 1500,
  },
});
export const ASSETS = Object.freeze({
  "view-1": {
    desktop:
      "https://cdn.prod.website-files.com/6a395067d36279ee102c060a/6a395bdb5143048565140f0c_e9ce8e0c1af9be47b3da689f973d8665_Comps%20View-Start%20Shot%20%28with%20comps%29.webp",
    mobile:
      "https://cdn.prod.website-files.com/6a395067d36279ee102c060a/6a395bdbe2e7d262648b987a_e17b7a873d62390814f8ad549c35eb5d_Comps%20View-Start%20Shot-MP%20%28with%20comps%29.webp",
  },
  "view-2": {
    desktop:
      "https://cdn.prod.website-files.com/6a395067d36279ee102c060a/6a3bdbbb958d98202a2e32f2_8cdf9d0fd2e7f78cec1523e74dbe4de4_View-2.png",
    mobile:
      "https://cdn.prod.website-files.com/6a395067d36279ee102c060a/6a3c409a1e19b544abe4a6e7_292e31508f45ed170de4bf297b590c93_View-2-MP.png",
  },
});
export const VIEW_START_END = Object.freeze({
  "view-1": {
    startTime: 0,
    endTime: 3,
  },
  "view-2": {
    startTime: 3.24,
    endTime: 6.2,
  },
});
export const LOOP_SEQUENCE_VIDS = true;
